<template>
  <div class="summary-box m-max-height" :class="{'summar-box-2':isUi2 }">
    <b-container>
      <b-row  v-if="!isUi2">
        <b-col class="summary-head title">
          <h4>Media Type Info</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
            <b-form-select v-model="order.MediaTypeName" style="margin-top: 10px;">
              <option v-for="item in options" :value="item.value">
                {{item.text}}
              </option>
            </b-form-select>
          <m-error-text :val="order.MediaTypeName" :immediate="showError" :rules="['require']"/>
        </b-col>
      </b-row>
      <template v-if="order.MediaTypeName === 'facebook'">
        <b-row class="item">
          <b-col lg="5" class="item-title">Share Account ID(*): </b-col>
          <b-col lg="7">
            <b-input :value = "order.ShareAccountId"
                     @input.native="updateMediaInfo('ShareAccountId', $event)"
                     size="sm"></b-input>
            <m-error-text :val="order.ShareAccountId" :immediate="showError" :rules="['require']"/>
          </b-col>
        </b-row><b-row class="item">
        <b-col lg="5" class="item-title">Package Name(*): </b-col>
        <b-col lg="7">
          <b-input :value = "order.PackageName"
                   @input.native="updateMediaInfo('PackageName', $event)"
                   size="sm"></b-input>
          <m-error-text :val="order.PackageName" :immediate="showError" :rules="['require']"/>
        </b-col>
      </b-row>
      </template>
      <template v-if="order.MediaTypeName === 'twitter'">
        <b-row class="item">
          <b-col lg="5" class="item-title">Tenant ID(*): </b-col>
          <b-col lg="7">
            <b-input :value = "order.TenantId"
                     @input.native="updateMediaInfo('TenantId', $event)"
                     size="sm"></b-input>
            <m-error-text :val="order.TenantId" :immediate="showError" :rules="['require']"/>
          </b-col>
        </b-row><b-row class="item">
        <b-col lg="5" class="item-title">Destination ID(*): </b-col>
        <b-col lg="7">
          <b-input :value = "order.DestinationId"
                   @input.native="updateMediaInfo('DestinationId', $event)"
                   size="sm"></b-input>
          <m-error-text :val="order.DestinationId" :immediate="showError" :rules="['require']"/>
        </b-col>
      </b-row><b-row class="item">
        <b-col lg="5" class="item-title">Destination Account ID(*): </b-col>
        <b-col lg="7">
          <b-input :value = "order.DestinationAccountId"
                   @input.native="updateMediaInfo('DestinationAccountId', $event)"
                   size="sm"></b-input>
          <m-error-text :val="order.DestinationAccountId" :immediate="showError" :rules="['require']"/>
        </b-col>
      </b-row>
      </template>
    </b-container>
  </div>
</template>
<script>
  import MErrorText from '@/components/common/MerrorText'
  export default {
    components: {
      MErrorText
    },
    props: {
      isUi2: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        options: [
          { text: 'Please Select Media Type', value: '' },
          { text: 'Facebook', value: 'facebook' },
          { text: 'Twitter', value: 'twitter' }
        ]
      }
    },
    computed: {
      showError () {
        return this.$store.getters['summary/showError']
      },
      order () {
        return this.$store.state.order
      }
    },
    methods: {
      updateMediaInfo (key, e) {
        this.$store.commit('order/saveKey', [
          key,
          e.target.value
        ])
      }
    }
  }
</script>

<style scoped lang="scss">
  .title {
    display: flex;
    justify-content: space-between;
  }
  .item {
    padding-top: 8px;
    font-size: 13px;
  }
  .item-title {
    padding-right: 0;
    margin-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/summary/MMediaTypeInfo.vue